module.exports = __webpack_public_path__ + "static/media/uxtesting-01.f70e0fc7.png";